module.exports = __webpack_public_path__ + "img/party_lower_3.91594046.jpg";